export default function dataReducer(state = {
    privacyData: {}
  }, action){
    switch (action.type) {
      case 'PRIVACY_DATA':
  
        console.log('adding ', action);
        
        
      return {...state, privacyData: action.tableData}
      
      default:
        return state;
    }
};